import React, { useState, useEffect } from "react";
import { Modal, Button, Input, Select, Divider } from "antd";
import { useAppData } from "./context/DataContext";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import axios from "axios";

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ indent: "-1" }, { indent: "+1" }],
    ["link"],
    ["clean"],
  ],
};

const QUILL_FORMATS = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
];

const MessageBlastModal = ({
  isVisible,
  onCancel,
  info,
  registeredIndex,
  approvedAttendees,
  selectedOrganizationInfo,
  defaultSelectedList,
}) => {
  const { loggedInUser } = useAppData();

  const navigate = useNavigate();
  const [text, setText] = useState("");
  const [subject, setSubject] = useState("");
  const [selectedLists, setSelectedLists] = useState(
    defaultSelectedList ? [defaultSelectedList] : []
  );

  useEffect(() => {
    if (defaultSelectedList) {
      setSelectedLists([defaultSelectedList]);
    }
  }, [defaultSelectedList]);

  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };

  const handleDescChange = (content) => {
    setText(content);
  };

  const sendMessageBlast = async () => {
    if (selectedLists.length === 0) {
      alert(
        "Please select at least one recipient list before sending the message."
      );
      return;
    }

    let emailList = [];

    selectedLists.map((list, index) => {
      if (list === "Registered Attendees") {
        emailList = [
          ...new Set([...emailList, ...info.registered[registeredIndex]]),
        ];
      } else if (list === "Approved Attendees") {
        emailList = [
          ...new Set([...emailList, ...approvedAttendees[registeredIndex]]),
        ];
      } else {
        const matchingList = selectedOrganizationInfo?.lists.find(
          (item) => item.name === list
        );
        if (matchingList) {
          emailList = [...new Set([...emailList, ...matchingList.emails])];
        }
      }
    });

    const payload = {
      email: emailList,
      eventName: info.name,
      eventURL: window.location.href,
      type: "Message Blast",
      eventLocation: info.location,
      dateTime:
        new Date(
          info.dates[registeredIndex].split("T")[0] + "T00:00:00"
        ).toLocaleDateString("en-US") +
        " @ " +
        new Date(`2000-01-01T${info.start_time}`).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        }),
      customSubject: subject,
      customText: text,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}sendEmail`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_UMMAHFY_API_KEY,
          },
        }
      );
      console.log("Response:", response.data);
    } catch (error) {
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
    }
  };

  return (
    <Modal
      title="Message Blast"
      open={isVisible}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            sendMessageBlast();
            onCancel();
          }}
          style={{
            backgroundColor: "#00224",
          }}
        >
          Send Message
        </Button>,
      ]}
      centered
    >
      <div>
        <Select
          style={{
            width: "100%",
            borderRadius: "4px",
            marginBottom: "12px",
            height: "36px",
          }}
          mode="multiple"
          placeholder="Send To"
          defaultValue={defaultSelectedList}
          dropdownRender={(menu) => (
            <>
              {menu}
              <Divider style={{ width: "100%", margin: "8px 0" }} />
              <Button
                style={{ padding: "8px", width: "100%" }}
                onClick={() => navigate("/lists")}
              >
                Create a List
              </Button>
            </>
          )}
          options={[
            {
              label: <span>Registered Attendees</span>,
              value: "Registered Attendees",
            },
            {
              label: <span>Approved Attendees</span>,
              value: "Approved Attendees",
              disabled: !info.requireApproval,
            },
            ...(selectedOrganizationInfo?.lists?.length > 0
              ? [
                  {
                    label: "Custom Lists",
                    type: "group",
                    options: selectedOrganizationInfo?.lists.map((list) => ({
                      label: <span>{list.name}</span>,
                      value: list.name,
                    })),
                  },
                ]
              : []),
          ]}
          onChange={(value) => {
            setSelectedLists(value);
          }}
        />

        <Input
          className="subject-input"
          placeholder="Subject"
          value={subject}
          onChange={handleSubjectChange}
        />
      </div>

      <div className="description-input1">
        <ReactQuill
          theme="snow"
          className="my-custom-quill"
          modules={QUILL_MODULES}
          formats={QUILL_FORMATS}
          value={text}
          onChange={handleDescChange}
        />
      </div>
    </Modal>
  );
};

export default MessageBlastModal;
